import React, {useEffect, useState, useRef} from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

export default function Collapsible({
                                      expandAll,
                                      main,
                                      children,
                                      showButton = true,
                                      customMainClassnames = '',
                                      customButtonClassnames = '',
                                    }) {
  const [expanded, setExpanded] = useState(expandAll ?? false);
  const contentRef = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    setExpanded(expandAll);
  }, [expandAll]);

  useEffect(() => {
    if (contentRef.current) {
      setHeight(contentRef.current.scrollHeight);
    }
  }, [children, expanded]);

  const handleToggle = () => {
    setExpanded(prev => !prev);
  };

  return (
    <div className={styles.collapsible}>
      <div className={classNames(styles.collapsibleMain, customMainClassnames)}>
        {main}

        {showButton && (
          <div
            onClick={handleToggle}
            className={classNames(styles.button, customButtonClassnames)}
          >
            <span
              className={classNames(styles.arrow, expanded && styles.expanded)}
            >
              ▼
            </span>
          </div>
        )}
      </div>

      <div
        className={styles.collapsibleWrapper}
        style={{
          maxHeight: expanded ? `${height}px` : '0px',
          overflow: 'hidden',
          transition: 'max-height 0.3s ease',
        }}
      >
        <div ref={contentRef}>{children}</div>
      </div>
    </div>
  );
}